import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./useCheckMobileScreen";

const Table = (props) => {
  const mac = mqtt_topics.choosenmac;
  const isMobile = useCheckMobileScreen();
  const [state, setState] = useStateIfMounted({
    value: [],
    htd: props.htd,
    title: props.title,
    disabled: false,
  });

  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic === target_live_reading_topic) {
      try {
        message = JSON.parse(message.toString());
        if (message.value && message.value.toString().toLowerCase() === "nv") {
          setState({
            ...state,
            value: [],
            disabled: true,
          });
        } else {
          setState({
            ...state,
            value: message.value ? message.value : [],
            disabled: false,
          });
        }
      } catch (error) {
        console.error("MQTT parse error", error);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
  }, []);

  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  // ---------- Extract Table Config ----------
  const tableConfig =
    state.htd && state.htd.elements_array && state.htd.elements_array[0]
      ? state.htd.elements_array[0]
      : {};
  const columns = tableConfig["Columns name"] || [];
  const rows = tableConfig["Raws name"] || [];

  return (
    <div className="col" style={{ display: state.disabled ? "none" : "block" }}>
      <div className="card text-center bg-light">
        <div
          className="card-header"
          style={{
            backgroundColor:
              state.title && state.title.toLowerCase().includes("power")
                ? "#ffffbd"
                : "",
          }}
        >
          {state.title}
        </div>

        <div className="card-body">
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th style={{ fontWeight: "bold" }}>{columns[0]}</th>
                {columns.slice(1).map((col, i) => (
                  <th key={i + 1} style={{ fontWeight: "bold" }}>
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((rowName, rowIndex) => (
                <tr key={rowIndex}>
                  {/* Bold only the first cell (row name) */}
                  <td style={{ fontWeight: "bold" }}>{rowName}</td>
                  {columns.slice(1).map((_, colIndex) => {
                    const rowArr = state.value[rowIndex] || [];
                    const cellValue =
                      rowArr[colIndex] !== undefined &&
                      rowArr[colIndex] !== null
                        ? rowArr[colIndex]
                        : "---";
                    return <td key={colIndex + 1}>{cellValue}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
